import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import RightArrow from '@material-ui/icons/ChevronRight';

import MoneyBankIcon from 'assets/genericBankIcons/money-bank.svg';
import ConnectedBankIcon from 'assets/genericBankIcons/connected-bank-small.svg';
import ManualBankIcon from 'assets/genericBankIcons/manual-bank-small.svg';

export const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'space-between',
  },
  leftSide: {
    flexGrow: 1,
    flexBasis: 465,
    backgroundColor: theme.palette.greyScale[7],
    padding: '32px 32px 24px 24px',
  },
  rightSide: {
    flexGrow: 1,
    flexBasis: 302,
    backgroundColor: theme.palette.color7.opacity30,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  longButton: {
    marginTop: 24,
    height: 88,
    width: '100%',
    borderRadius: 8,
    border: `1px solid ${theme.palette.greyScale[4]}`,
    textTransform: 'none',
    padding: '12px 24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  buttonText: {
    textAlign: 'left',
    flexGrow: 1,
  },
}));


export default function PlaidLanding (props) {

  const classes = useStyles();
  const { goPlaid, goManual } = props;

  return (
    <div className={classes.root}>
      <div className={classes.leftSide}>
        <Typography variant="body2">
          Simplifi connects to over 9,000 financial institutions.
        </Typography>


        <Button className={classes.longButton} onClick={goPlaid}>
          <img src={ConnectedBankIcon} alt="ConnectedIcon" style={{ width: 46, marginRight: 8, marginTop: 6 }} />

          <Typography variant="subtitle2" className={classes.buttonText}>
            Connect an existing financial institution
          </Typography>

          <RightArrow />
        </Button>

        <Button className={classes.longButton} onClick={goManual}>
          <img src={ManualBankIcon} alt="ManualIcon" style={{ width: 38, marginRight: 16 }} />

          <Typography variant="subtitle2" className={classes.buttonText}>
            Create a manual or asset account
          </Typography>

          <RightArrow />
        </Button>
      </div>

      <div className={classes.rightSide}>
        <img src={MoneyBankIcon} alt="MoneyBankIcon" style={{ paddingBottom: 70 }} />
      </div>
    </div>);
}

PlaidLanding.propTypes = {
  goManual: PropTypes.func,
  goPlaid: PropTypes.func,
};

